<template>
  <div class="row">
    <div class="col-12">
      <h4 class="text-center mb-3">Modelos de não conformidade</h4>
      <DataTable
        :value="noncompliance_models"
        :lazy="true"
        :paginator="true"
        :rows="10"
        :total-records="total_noncompliance_models"
        :loading="loading"
        class="p-datatable-gridlines p-datatable-sm"
        data-key="noncompliance_model_id"
        :row-hover="true"
        @page="onPage($event)"
        @sort="onSort($event)"
        ref="datatable"
      >
        <template #empty> Nenhum resultado </template>
        <template #loading> Carregando </template>
        <Column field="noncompliance_model_id" header="ID"></Column>
        <Column
          field="noncompliance_model_description"
          header="Descrição"
        ></Column>
        <Column
          field="noncompliance_model_nature_of_risk.name"
          header="Natureza do risco"
        ></Column>
        <Column>
          <template #body="slotProps">
            <div class="d-flex flex-nowrap justify-content-end">
              <router-link
                :to="
                  '/noncompliance-models/edit/' +
                  slotProps.data.noncompliance_model_id
                "
              >
                <button class="btn btn-warning ml-3">
                  <font-awesome-icon
                    :icon="['fas', 'wrench']"
                  ></font-awesome-icon>
                </button>
              </router-link>

              <button
                class="btn btn-danger ml-3"
                @click="
                  onDelete(
                    slotProps.data.noncompliance_model_id,
                    slotProps.index,
                  )
                "
              >
                <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
              </button>
            </div>
          </template>
        </Column>
      </DataTable>
      <router-link class="btn btn-dark mt-3" to="/noncompliance-models/create">
        <font-awesome-icon :icon="['fas', 'save']"></font-awesome-icon>
        Novo modelo de não conformidade
      </router-link>
    </div>
  </div>
</template>

<script>
  import { onMounted, ref } from 'vue'

  import DataTable from 'primevue/datatable'
  import Column from 'primevue/column'

  import useNoncomplianceModel from '@/modules/NoncomplianceModel.js'
  import useSwal from '@/modules/Swal.js'

  export default {
    components: {
      DataTable,
      Column,
    },
    setup() {
      const page = ref(1)
      const per_page = ref(10)
      const datatable = ref(null)

      const {
        noncompliance_models,
        listNoncomplianceModels,
        destroyNoncomplianceModel,
        total_noncompliance_models,
        loading,
      } = useNoncomplianceModel()

      const { showConfirmDeletionSwal } = useSwal()

      const onPage = (event) => {
        page.value = event.page + 1

        listNoncomplianceModels(page.value, per_page.value)
      }

      onMounted(() => {
        listNoncomplianceModels(page.value, per_page.value)
      })

      return {
        datatable,
        loading,
        onPage,
        noncompliance_models,
        showConfirmDeletionSwal,
        total_noncompliance_models,
        destroyNoncomplianceModel,
      }
    },
    methods: {
      onDelete(noncompliance_model_id, index) {
        this.showConfirmDeletionSwal()
          .then((response) => {
            if (response.isConfirmed) {
              this.destroyNoncomplianceModel(noncompliance_model_id, index)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
    },
  }
</script>
